// src/lib/juliette-addcal.ts
// Extrait le marqueur [ADDCAL:<url>] d'une reponse de Juliette : renvoie le texte
// nettoye (marqueur retire, y compris un marqueur partiel pendant le streaming) +
// l'URL du bouton "Ajouter a mon agenda" (ou null). Le meme marqueur est retire du
// TTS cote serveur (normalizeForTts) pour ne jamais etre lu a voix haute.
const ADDCAL_RE = /\[ADDCAL:(https?:\/\/[^\]]+)\]/i;

export function extractAddCal(content: string): { text: string; addUrl: string | null } {
  if (!content) return { text: content, addUrl: null };
  const match = content.match(ADDCAL_RE);
  const text = content
    .replace(ADDCAL_RE, "")
    .replace(/\[ADDCAL:[^\]]*$/i, "") // marqueur incomplet en cours de streaming
    .replace(/\n{3,}/g, "\n\n")
    .trimEnd();
  return { text, addUrl: match ? match[1] : null };
}
